import {SVGProps} from 'react'
const SvgLifeRing = (props: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx={8} cy={8} r={3.5} stroke="#788492" />
    <circle cx={8} cy={8} r={6.5} stroke="#788492" />
    <path d="M2 8h2.5M11 8h3.5M8 11v3M8 2v3" stroke="#788492" />
  </svg>
)
export default SvgLifeRing
